// /src/components/tools/memberProfileCard/PerkThemeHaloLayer.jsx
// Soft inset halo + optional spiral OR frost (mutually exclusive) from effectConfig.

import React from 'react';
import {
  getPerkThemeHaloClass,
  resolvePerkThemeHalo,
} from '../../../utils/perkThemeHalo';
import PerkThemeHaloFrostCanvas from './PerkThemeHaloFrostCanvas';
import PerkThemeHaloSpiralCanvas from './PerkThemeHaloSpiralCanvas';

export default function PerkThemeHaloLayer({ effectConfig = null }) {
  const halo = resolvePerkThemeHalo(effectConfig);
  if (!halo.enabled) return null;

  const softClass = getPerkThemeHaloClass(halo.color, { opacity: 0.38 });

  return (
    <>
      {softClass ? (
        <div className={`perk-theme-frame-halo ${softClass}`} aria-hidden />
      ) : null}
      {halo.frozen > 0 ? (
        <PerkThemeHaloFrostCanvas color={halo.color} frozen={halo.frozen} />
      ) : null}
      {halo.spiral > 0 && halo.frozen <= 0 ? (
        <PerkThemeHaloSpiralCanvas color={halo.color} spiral={halo.spiral} />
      ) : null}
    </>
  );
}
